import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import type {BrandKitSwatchClusterProps} from './brand-kit-swatch-cluster.types';
import {BrandKitSwatchClusterVariant} from './brand-kit-swatch-cluster.types';
import {AiChatTestId} from '@/test-ids/ai-chat-test-id';
import styles from './brand-kit-swatch-cluster.module.scss';

const CLUSTER_CLASS_BY_VARIANT: Record<BrandKitSwatchClusterVariant, string> = {
  [BrandKitSwatchClusterVariant.DEFAULT]: styles.default,
  [BrandKitSwatchClusterVariant.COMPACT]: styles.compact,
  [BrandKitSwatchClusterVariant.SPACED]: styles.spacedSwatchCluster,
};

export function BrandKitSwatchCluster({logoURL, colorHexes, variant = BrandKitSwatchClusterVariant.DEFAULT, colorLimit}: BrandKitSwatchClusterProps): ReactElement | null {
  const shownColorHexes = colorLimit === undefined ? colorHexes : colorHexes.slice(0, colorLimit);
  const hiddenColorCount = colorHexes.length - shownColorHexes.length;

  const getLogoSwatch = (): ReactElement | null => {
    if (!logoURL) {
      return null;
    }

    return (
      <div className={styles.swatch}>
        <img className={styles.logo} src={logoURL} alt="" />
      </div>
    );
  };

  const getColorSwatches = (): ReactElement[] => {
    return shownColorHexes.map((colorHex, index) => {
      return <div key={`${colorHex}-${index}`} className={styles.swatch} style={{backgroundColor: colorHex}} data-testid={AiChatTestId.BRAND_KIT_COLOR_SWATCH} />;
    });
  };

  const getHiddenColorCount = (): ReactElement | null => {
    if (hiddenColorCount <= 0) {
      return null;
    }

    return <Text val={`+${hiddenColorCount}`} size={TextSize.XS} bold className={styles.hiddenColorCount} />;
  };

  if (!logoURL && colorHexes.length === 0) {
    return null;
  }

  return (
    <div className={`${styles.cluster} ${CLUSTER_CLASS_BY_VARIANT[variant]}`} aria-hidden="true">
      {getLogoSwatch()}
      {getColorSwatches()}
      {getHiddenColorCount()}
    </div>
  );
}
